import React, { FC } from 'react';
import { StatsPanelContainer } from './Styles';
import { StatsPanelProps } from './types';

export const StatsPanel: FC<StatsPanelProps> = ({ children, ...rest }) => (
  <StatsPanelContainer {...rest}>{children}</StatsPanelContainer>
);
